import { QA_API_DOMAIN, fetchWithSupabaseAuth } from "@/api/classifier";
import type { LlmModelListing } from "@smartmed/llm-models";
import { useQuery } from "@tanstack/react-query";

const LLM_MODELS_URL = `${QA_API_DOMAIN}/llm-models`;

export const useLlmModels = () => {
  const result = useQuery({
    queryKey: ["llm-models"],
    queryFn: async () => {
      const response = await fetchWithSupabaseAuth(LLM_MODELS_URL);
      if (!response.ok) {
        throw new Error("Failed to fetch LLM models");
      }
      const body = (await response.json()) as LlmModelListing[];
      // Return the full model objects instead of just IDs
      return body;
    },
  });

  return result;
};
